import React from 'react';
import { Input } from './ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Button } from './ui/button';
import { Search, Filter, X } from 'lucide-react';

const TransactionFilters = ({ 
  filters, 
  setFilters,
  categories = [],
  accounts = [],
  onClear
}) => {
  const hasFilters = filters.search || filters.type || filters.category_id || filters.account_id || filters.start_date || filters.end_date;

  return (
    <div className="bg-white rounded-lg p-4 mb-4 space-y-4">
      {/* Search */}
      <div className="relative">
        <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <Input
          placeholder="Search transactions..."
          value={filters.search || ''}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          className="pl-10"
          data-testid="global-search-input"
        />
      </div>

      {/* Filter row */}
      <div className="flex flex-wrap gap-3">
        {/* Type */}
        <Select
          value={filters.type || 'all'}
          onValueChange={(value) => setFilters({ ...filters, type: value === 'all' ? '' : value })}
        >
          <SelectTrigger className="w-[140px]" data-testid="type-filter">
            <SelectValue placeholder="All Types" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="revenue">Revenue</SelectItem>
            <SelectItem value="expense">Expense</SelectItem>
            <SelectItem value="transfer">Transfer</SelectItem>
          </SelectContent>
        </Select>

        {/* Category */}
        {categories.length > 0 && (
          <Select
            value={filters.category_id || 'all'}
            onValueChange={(value) => setFilters({ ...filters, category_id: value === 'all' ? '' : value })}
          >
            <SelectTrigger className="w-[160px]" data-testid="category-filter">
              <SelectValue placeholder="All Categories" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Categories</SelectItem>
              {categories.map((cat) => (
                <SelectItem key={cat.id} value={cat.id}>
                  {cat.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}

        {/* Account */}
        {accounts.length > 0 && (
          <Select
            value={filters.account_id || 'all'}
            onValueChange={(value) => setFilters({ ...filters, account_id: value === 'all' ? '' : value })}
          >
            <SelectTrigger className="w-[160px]" data-testid="account-filter">
              <SelectValue placeholder="All Accounts" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Accounts</SelectItem>
              {accounts.map((acc) => (
                <SelectItem key={acc.id} value={acc.id}>
                  {acc.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}

        {/* Date Range */}
        <Input
          type="date"
          placeholder="From"
          value={filters.start_date || ''}
          onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
          className="w-[150px]"
          data-testid="date-from-filter"
        />
        <Input
          type="date"
          placeholder="To"
          value={filters.end_date || ''}
          onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
          className="w-[150px]"
          data-testid="date-to-filter"
        />

        {/* Clear button */}
        {hasFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClear}
            className="text-gray-500"
            data-testid="clear-filters-button"
          >
            <X size={16} className="mr-1" />
            Clear
          </Button>
        )}
      </div>
    </div>
  );
};

export default TransactionFilters;
